import React, { useState, useEffect, useRef } from "react";
import * as _f_ from "@Funciones/funciones";
import "./ListaUL.css";

export const ListaUL = ({
  texto,
  name,
  listaElementos = [],
  estilos = {},
  ...props
}) => {
  return (
    <div
      className="ListaUL"
      id={`ListaUL-${name}`}
      style={_f_.estilosObjetoVariablesCSS(estilos)}
      {...props}
    >
      {texto ?? ""}
      <ul>
      {listaElementos.map((elemento,i) => {
        return <li key={i}>{elemento}</li>
      })}
      </ul>
    </div>
  );
};
